export const SET_RECORDED_AUDIO = 'VOICEOVER/SET_RECORDED_AUDIO'
